{
  "blocks": [
    {
      "id": "proc-embryo-biopsy-pgt",
      "kind": "procedure",
      "tags": ["ivf", "genomic", "lab", "both-partners"],
      "title": "Embryo biopsy",
      "subtitle": "Removing a small number of cells from a blastocyst for separate laboratory testing",
      "body": {
        "procedureName": "Embryo biopsy",
        "category": "lab",
        "description": "A laboratory procedure that removes a small number of cells from a blastocyst. The sample can then be sent for a separate genetic test such as PGT-A, PGT-M, or PGT-SR.",
        "howItWorks": "On Day 5-6, when the embryo has reached the blastocyst stage, an embryologist uses a laser to make a small opening in the outer shell and removes 5-10 cells from the trophectoderm (the part that becomes the placenta, not the baby). The sample is sent to the laboratory for the separately ordered analysis while the embryo is frozen. The biopsy itself does not produce a genetic result; the laboratory test determines what information is reported and how long it takes.",
        "duration": "Same day as Day 5-6 culture",
        "costRange": {
          "low": 3000,
          "high": 6000
        },
        "currency": "USD",
        "whatToExpect": [
          "The embryo is frozen after biopsy while the sample is sent to the laboratory",
          "The laboratory performs the separate analysis ordered by your care team",
          "Your clinic explains the testing timeline and next steps",
          "Embryo transfer is scheduled separately if it is appropriate for your plan"
        ],
        "results": [
          {
            "label": "When you hear",
            "detail": "The biopsy itself does not produce a genetic result. The timeline belongs to the separate laboratory test ordered on the sample."
          },
          {
            "label": "What you learn",
            "detail": "The sample may be used for PGT-A, PGT-M, PGT-SR, or another laboratory analysis, depending on what was ordered."
          },
          {
            "label": "How it is used",
            "detail": "Your doctor or genetic counselor should explain the separate report and how it may inform decisions about transfer."
          }
        ],
        "risks": [
          "Very small risk of embryo damage during biopsy (<1%)",
          "Not all embryos may be suitable for biopsy"
        ],
        "forWhom": "both",
        "frBody": {
          "procedureName": "Biopsie embryonnaire",
          "description": "Prélèvement de quelques cellules du blastocyste. L'échantillon peut ensuite être envoyé au laboratoire pour une analyse génétique distincte, selon l'examen demandé et la réglementation applicable.",
          "howItWorks": "À J5-J6, lorsque l'embryon a atteint le stade blastocyste, un embryologiste utilise un laser pour créer une petite ouverture dans la zone pellucide et prélève 5 à 10 cellules du trophectoderme (la partie qui deviendra le placenta, pas le bébé). L'échantillon est envoyé au laboratoire pour l'analyse distincte demandée pendant que l'embryon est congelé. La biopsie elle-même ne produit pas de résultat génétique ; le délai dépend de l'examen de laboratoire demandé et de la réglementation applicable.",
          "duration": "Le jour même de la culture à J5-J6",
          "whatToExpect": [
            "L'embryon est congelé après la biopsie et l'échantillon est envoyé au laboratoire",
            "Le laboratoire réalise l'analyse distincte demandée par votre équipe",
            "Votre centre explique le délai d'analyse et les prochaines étapes",
            "Le transfert embryonnaire est programmé séparément s'il est adapté à votre parcours"
          ],
          "results": [
            {
              "label": "Quand vous avez des nouvelles",
              "detail": "La biopsie elle-même ne produit pas de résultat génétique. Le délai dépend de l'analyse de laboratoire demandée."
            },
            {
              "label": "Ce que vous apprenez",
              "detail": "L'échantillon peut être utilisé pour un DPI-A, DPI-M, DPI-SR ou une autre analyse selon la prescription."
            },
            {
              "label": "Comment c'est utilisé",
              "detail": "Votre médecin ou conseiller en génétique doit expliquer le compte rendu et son éventuel rôle dans la décision de transfert."
            }
          ],
          "risks": [
            "Risque très faible d'altération embryonnaire pendant la biopsie (<1 %)",
            "Tous les embryons ne sont pas éligibles à la biopsie"
          ]
        }
      },
      "sources": [
        {
          "title": "Preimplantation genetic testing for aneuploidies (STAR trial)",
          "authors": "Munné S et al.",
          "journal": "Fertility and Sterility",
          "year": 2019,
          "url": "https://pubmed.ncbi.nlm.nih.gov/31551155/",
          "evidenceLevel": "rct"
        },
        {
          "title": "The use of preimplantation genetic testing for aneuploidy: a committee opinion",
          "authors": "Practice Committees of ASRM and SART",
          "journal": "Fertility and Sterility",
          "year": 2024,
          "url": "https://www.asrm.org/practice-guidance/practice-committee-documents/the-use-of-preimplantation-genetic-testing-for-aneuploidy-a-committee-opinion-2024/",
          "evidenceLevel": "guideline"
        }
      ]
    }
  ],
  "relationships": [
    {
      "from": "proc-embryo-biopsy-pgt",
      "to": "test-preimplantation-genetic-testing",
      "type": "related-to",
      "label": "Sample collected for"
    }
  ],
  "localeVariants": []
}
